import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Observable} from 'rxjs';
import {SelectItemGroup} from 'primeng/api';
import {LeisureRepository} from '@app/@core/repositories/leisure.repository';
import {map} from 'rxjs/operators';
import {LeisureShop} from '@app/@core/domain/leisure.model';

interface KV {
    id?: string;
    name?: string;
}

@Component({
    selector: 'app-shop-leisure-select',
    templateUrl: './shop-leisure-select.component.html',
    styleUrls: []
})
export class ShopLeisureSelectComponent implements OnInit {
    @Input() shopId: string | string[];
    @Input() multi = false;
    @Input() styleClass: string;

    @Output() shopIdChange = new EventEmitter<string | string[]>();
    @Output() onChanged = new EventEmitter<KV | KV[]>();

    groupedOptions: Observable<SelectItemGroup[]>;

    constructor(
        private leisureRepository: LeisureRepository
    ) {
    }

    ngOnInit(): void {
        this.groupedOptions = this.leisureRepository.getShopList().pipe(
            map((shops: LeisureShop[]) => {
                const openShops = shops.filter(shop => shop.status === 'OPEN');

                return [
                    {
                        label: 'Open Shops',
                        items: openShops.map(shop => ({
                            label: shop.nameTH || shop.name,
                            value: shop.id
                        }))
                    }
                ];
            })
        );
    }

    changed(event: any): void {
        this.shopIdChange.emit(event);
        this.onChanged.emit(event);
    }

}
